import { useTranslation } from '@klv/hooks/useTranslation';

import { generateClassName } from '@klv/shared/utils/functions';
import { Anchor } from '@klv/atoms/anchor';
import * as styles from './styles/glossary.module.css';

import type { IGlossary } from './types';


const LinkBar = ({ letters, sortedTerms }: { letters: string[]; sortedTerms: IGlossary['sortedTerms']; }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.glossaryLinkBar}>
      <div className={styles.mobileLinks}>
        <div>{t('organisms_glossary_jumpTo')}</div>
        <div className={styles.mobileSelectWrapper}>
          <select className={styles.mobileSelect} onChange={(e) => { document.getElementById(`glossary-${e.target.value}`)?.scrollIntoView(); }}>
            {letters.map((letter) => (
              <option key={letter} disabled={(sortedTerms[letter].length === 0)} value={letter}>
                {letter.toUpperCase()}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className={styles.desktopLinks}>
        {letters.map((letter) => (sortedTerms[letter].length > 0)
          ? (<a key={letter} href={`#glossary-${letter}`}>{letter.toUpperCase()}</a>)
          : (<div key={letter}>{letter.toUpperCase()}</div>))}
      </div>
    </div>
  );
};

const LetterSection = ({ letter, terms }: { letter: string; terms: IGlossary['terms']; }) => {
  return (<div className={styles.letterSection}>
    <h2 className={styles.sectionHeading} id={`glossary-${letter}`}>{letter.toUpperCase()}</h2>
    <ul>
      {terms.map(({ title, uri }) => (
        <li key={uri}>
          <Anchor href={uri}>{title}</Anchor>
        </li>
      ))}
    </ul>
  </div>
  );
};

export const Glossary = ({
  componentType,
  className = '',
  terms,
  sortedTerms,
  ...props
}: IGlossary) => {
  const letters = Object.keys(sortedTerms);

  return (
    <div className={generateClassName([className, styles.glossary])} {...props}>
      <LinkBar letters={letters} sortedTerms={sortedTerms} />
      <div className={generateClassName(['grid'])}>
        {letters.map((letter) => (sortedTerms[letter].length > 0) ? (<LetterSection key={letter} letter={letter} terms={sortedTerms[letter]} />) : null)}
      </div>
    </div>
  );
};
